import {
  ChangeDetectorRef,
  Directive,
  HostBinding,
  OnDestroy,
  inject,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { PopoverRef } from '../models';

/**
 * Internal directive that shows the popover arrow.
 */
@Directive({
  selector: '[qtPopoverArrow]',
  standalone: false,
})
export class PopoverArrowDirective implements OnDestroy {
  private popoverRef = inject(PopoverRef);
  private cd = inject(ChangeDetectorRef);

  @HostBinding('style.width.px')
  @HostBinding('style.height.px')
  arrowSize: number;

  @HostBinding('style.top.px')
  offsetTop: number;

  @HostBinding('style.right.px')
  offsetRight: number;

  @HostBinding('style.bottom.px')
  offsetBottom: number;

  @HostBinding('style.left.px')
  offsetLeft: number;

  private subscription = new Subscription();

  constructor() {
    const popoverRef = this.popoverRef;

    this.arrowSize = popoverRef.config.arrowSize;

    this.subscription = popoverRef.positionChanges().subscribe(p => {
      const { offsetX, offsetY } = p.connectionPair;

      this.offsetTop = offsetY >= 0 ? offsetY * -1 : null;
      this.offsetLeft = offsetX < 0 ? offsetX * -1 : null;
      this.offsetBottom = offsetY < 0 ? offsetY : null;
      this.offsetRight = offsetX >= 0 ? offsetX : null;

      this.cd.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
